import { 
    SET_ONBOARDING_MODE, 
    SET_GMAIL_MODE, 
    SET_USER_SESSION,
    SET_HIDDEN_LOADING_BAR 
} from '../actions';

const initState = {
    gmailMode: false,
    onboarding: null,
    userSession: null,
    hiddenLoadingbar: 0
}

const actionSubstateMap = {
    SET_GMAIL_MODE: 'gmailMode',
    SET_ONBOARDING_MODE: 'onboarding',
    SET_USER_SESSION: 'userSession',
    SET_HIDDEN_LOADING_BAR: 'hiddenLoadingbar'
}


const setAppData = (state, key, data) => {
    return { ...state, [key]: data };
}
const handleLoadingBar = (state, data) => {
    const newState = state + (data ? 1 : -1);
    return newState >= 0 ? newState : 0;
}
export const appModesReducer = function(state = initState, action){
    const { type, payload } = action;
    switch(action.type) {
        case SET_GMAIL_MODE:
        case SET_ONBOARDING_MODE:
        case SET_USER_SESSION:
            return setAppData(state, actionSubstateMap[type], payload);
        case SET_HIDDEN_LOADING_BAR:
            return { ...state, hiddenLoadingbar: handleLoadingBar(state.hiddenLoadingbar, payload) };
        default:
            return state;
    }
}